<section class="flex flex-col font-display">
  <span class="text-2xl sm:text-3xl font-bold">Employee</span>
  <div class="flex flex-col gap-4 w-full sm:w-1/2 lg:w-1/3">
    <div class="flex flex-wrap items-center gap-3 mt-6">
      <button
        (click)="addEmployee()"
        class="w-full sm:w-auto min-w-52 h-12 rounded-lg bg-[#42A5CE] text-white flex items-center justify-center space-x-2"
      >
        <i class="fa-solid fa-plus"></i>
        <span>Add New Employee</span>
      </button>
    </div>
    <div class="relative">
      <input
        type="text"
        [formControl]="searchFormControl"
        class="w-full h-12 border border-gray-200 rounded-lg p-4 pl-11 text-[#5C5C5C] text-sm focus:outline-none"
        placeholder="Cari..."
      />
      <i class="fa-solid fa-magnifying-glass absolute left-4 top-4"></i>
    </div>
  </div>
  <div class="overflow-x-auto">
  <table mat-table
      [dataSource]="dataSource"
      class="mat-elevation-z0 mt-6 font-display min-w-max w-full"
    >
      <ng-container matColumnDef="no">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!font-semibold text-base sm:text-lg whitespace-nowrap"
        >
          No.
        </th>
        <td mat-cell *matCellDef="let element; let i = index">
          {{ parseNo(i) || "-" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="firstName">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!font-semibold text-base sm:text-lg whitespace-nowrap"
        >
          Name
        </th>
        <td mat-cell *matCellDef="let element">
          <div class="flex">
            <img
              [src]="element.imageUrl || 'profile.png'"
              alt="Foto Profil"
              class="w-10 h-10 rounded-lg object-cover"
            />
            <div class="flex flex-col ml-2">
              <span class="font-bold"
                >{{ element.firstName || "-" }}
                {{ element.lastName || "" }}</span
              >
              <span>{{ element.email || "-" }}</span>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="employeeId">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!font-semibold text-base sm:text-lg whitespace-nowrap"
        >
          Employee ID
        </th>
        <td mat-cell *matCellDef="let element">
          <span
            *ngIf="element.employeeId; else emptyEmployeeId"
            class="inline-flex items-center rounded-md bg-slate-100 px-2 py-1 text-xs font-semibold text-slate-900"
            >{{ element.employeeId }}</span
          >
          <ng-template #emptyEmployeeId>-</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="team">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!font-semibold text-base sm:text-lg whitespace-nowrap"
        >
          Team
        </th>
        <td mat-cell *matCellDef="let element">
          <span
            *ngIf="element.team?.name; else emptyTeam"
            class="inline-flex items-center rounded-md bg-slate-100 px-2 py-1 text-xs font-semibold text-slate-900"
            >{{ element.team?.name }}</span
          >
          <ng-template #emptyTeam>-</ng-template>
        </td>
      </ng-container>

      <ng-container matColumnDef="position">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!font-semibold text-base sm:text-lg whitespace-nowrap"
        >
          Position
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.position || "-" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="created_at">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!font-semibold text-base sm:text-lg whitespace-nowrap"
        >
          Created Date
        </th>
        <td mat-cell *matCellDef="let element">
          {{
            element.created_at ? (element.created_at | date : "fullDate" : "+0700") : "-"
          }}
        </td>
      </ng-container>

      <ng-container matColumnDef="updated_at">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!font-semibold text-base sm:text-lg whitespace-nowrap"
        >
          Modified Date
        </th>
        <td mat-cell *matCellDef="let element">
          {{
            element.updated_at ? (element.updated_at | date : "fullDate" : "+0700") : "-"
          }}
        </td>
      </ng-container>

      <ng-container stickyEnd matColumnDef="action">
        <th
          mat-header-cell
          *matHeaderCellDef
          class="!font-semibold text-base sm:text-lg whitespace-nowrap"
        >
          Action
        </th>
        <td mat-cell *matCellDef="let element">
          <button
            type="button"
            [matMenuTriggerFor]="menu"
            class="inline-flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 text-slate-600 hover:border-slate-300 hover:text-slate-900"
          >
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </button>

          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="editEmployee(element.id)">
              <span class="font-display text-sm">
                <i class="fa-solid fa-pen-to-square mr-3"></i>Edit
              </span>
            </button>
            <button mat-menu-item (click)="remove(element)">
              <span class="font-display text-sm">
                <i class="fa-solid fa-trash mr-3"></i>Hapus
              </span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          <div
            class="w-full flex flex-col items-center justify-center gap-2 py-6 text-center font-display"
          >
            <div
              class="flex h-10 w-10 items-center justify-center rounded-full bg-slate-100 text-slate-400"
            >
              <i class="fa-solid fa-inbox"></i>
            </div>
            <span class="text-sm font-semibold text-slate-700"
              >No data available</span
            >
            <span class="text-xs text-slate-500"
              >Try adjusting filters or search.</span
            >
          </div>
        </td>
      </tr>
    </table>
</div>
  <mat-paginator
    [length]="dataTotal"
    [pageSize]="limit"
    [pageSizeOptions]="pageSizeOption"
    (page)="onPageChange($event)"
    aria-label="Select page"
  >
  </mat-paginator>
</section>
